// import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate, useLocation, Outlet, useParams} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
// import TopBarProgress from 'react-topbar-progress-indicator'
// import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
// import {WithChildren} from '../../_metronic/helpers'
import {IssueAreasPage} from '../pages/admin/IssueAreas/IssueAreasPage'
import {FTAImpactProvider} from '../contexts/fta-impact/FTAImpactContext'
import {AbilityContext} from '../modules/auth/core/AbilityContext'
import {useAbility} from '@casl/react'

import DashboardPage from '../pages/admin/dashboard/DashboardPage'
import HomePage from '../pages/national/home/HomePage'
import FTAImpactPage from '../pages/national/fta-impact/FTAImpactPage'
import InputOutputPage from '../pages/national/input-output-analyis/InputOutputPage'
import PreferenceLossPage from '../pages/national/preference-loss/PreferenceLossPage'
import TradePotentialCommodityPage from '../pages/national/trade-potential-commodity/TradePotentialCommodityPage'
import TradePotentialPage from '../pages/national/trade-potential/TradePotentialPage'
import TradeDataManagementPage from '../pages/admin/trade-data-management/TradeDataManagementPage'
import TradeDataManagementDetailPage from '../pages/admin/trade-data-management-detail/TradeDataManagementDetailPage'
import AgreementPage from '../pages/admin/trade-data-agreement/TradeDataAgreementPage'
import AgreementDetailPage from '../pages/admin/trade-data-agreement-detail/TradeDataAgreementDetailPage'
import AgreementChapterPage from '../pages/admin/trade-data-agreement-chapter/TradeDataAgreementChapterPage'
import AgreementChapterReorderPage from '../pages/admin/trade-data-agreement-chapter/AgreementChapterReorderPage'
import AgreementChapterReviewPage from '../pages/admin/trade-data-agreement-chapter-review/TradeDataAgreementChapterReviewPage'
import TariffPage from '../pages/admin/tariff/TariffPage'
import TariffDetailPage from '../pages/admin/tariff-detail/TariffDetailPage'
import MasterDataHSPage from '../pages/admin/master-data-hs/MasterDataHSPage'
import MasterDataHSDetailPage from '../pages/admin/master-data-hs-detail/MasterDataHSDetailPage'
import ManageUserRolePage from '../pages/admin/manage-user-role/ManageUserRolePage'
import ManageAvailableRolesPage from '../pages/admin/manage-available-roles/ManageAvailableRolesPage'
import ManageAvailableRolesDetailPage from '../pages/admin/manage-available-roles/ManageAvailableRolesDetailPage'
import ManageUserRoleDetailPage from '../pages/admin/manage-user-role/ManageUserRoleDetailPage'
import NoPermissionCard from '../../_metronic/layout/components/permission/NoPermissionCard'
import TradeDataAgreementNewPage from '../pages/admin/trade-data-agreement-new/TradeDataAgreementNewPage'
import TradeDataAgreementDetailNewPage from '../pages/admin/trade-data-agreement-detail-new/TradeDataAgreementDetailNewPage'
import TradeDataAgreementChapterNewPage from '../pages/admin/trade-data-agreement-chapter-new/TradeDataAgreementChapterNewPage'
import TradeDataAgreementChapterReviewNewPage from '../pages/admin/trade-data-agreement-chapter-review-new/TradeDataAgreementChapterReviewNewPage'
import TradeDataAgreementReviewPage from '../pages/admin/trade-data-agreement-review/TradeDataAgreementReviewPage'
import TariffReviewPage from '../pages/admin/tariff-review/TariffReviewPage'

// export const ROLES = {
//   superadmin: 1,
//   tina_admin: 2,
//   cambodia_member: 3,
//   tina_member: 4,
//   bangladesh_member: 5,
//   aptiad_admin: 6,
// }

const PrivateRoutes = () => {
  const ability = useAbility(AbilityContext)
  // NOTE: Route subject must be same as dss_menus.title to ensure the permission running properly

  const homeElement = ability.can('read', 'menuForUserHasEconomy') ? (
    <HomePage />
  ) : (
    <DashboardPage />
  )

  return (
    <FTAImpactProvider>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          <Route path='login/*' element={<Navigate to='/home' />} />
          <Route path='/' element={<Navigate to='/home' />} />
          <Route path='home' element={homeElement} />
          <Route path='third-party-impacts' element={<FTAImpactPage />} />
          <Route path='trade-prospect' element={<TradePotentialPage />} />
          <Route path='trade-prospect-commodity' element={<TradePotentialCommodityPage />} />
          <Route
            path='trade-prospect-commodity/:hs_code'
            element={<TradePotentialCommodityPage />}
          />
          <Route path='input-output-analysis' element={<InputOutputPage />} />
          <Route
            path='preference-loss'
            element={
              <PermissionWrapper subject='menuForUserHasEconomy'>
                <PreferenceLossPage />
              </PermissionWrapper>
            }
          />

          {/* Admin Page */}
          <Route
            path='issue-areas-content-management'
            element={
              // <PermissionWrapper subject='MENU.ISSUE_AREAS'>
              <IssueAreasPage subject='MENU.ISSUE_AREAS' />
              // </PermissionWrapper>
            }
          />
          {/* Trade Data */}
          <Route
            path='trade-data'
            element={
              <PermissionWrapper subject='MENU.TRADE_DATA'>
                <TradeDataManagementPage subject='MENU.TRADE_DATA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='trade-data/:countrycode'
            element={
              <PermissionWrapper subject='MENU.TRADE_DATA'>
                <TradeDataManagementDetailPage subject='MENU.TRADE_DATA' />
              </PermissionWrapper>
            }
          />
          {/* Agreement */}
          <Route
            path='agreement'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/add'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementDetailPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/:idAgreement'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementDetailPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/:idAgreement/chapter/add'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementChapterPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/:idAgreement/chapter/edit-order'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementChapterReorderPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/review-chapter/:idReview'
            element={
              <PermissionWrapper subject='PERM_APPROVE_AGREEMENT'>
                <AgreementChapterReviewPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='agreement/chapter/:idChapter/edit'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <AgreementChapterPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          {/* RTA new */}
          <Route
            path='new-rta'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/add'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementDetailNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/:idAgreement'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementDetailNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/:idAgreement/chapter/add'
            element={
              <PermissionWrapper subject='MENU.NEW_RTA'>
                <TradeDataAgreementChapterNewPage subject='MENU.NEW_RTA' />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/review-chapter/:idReview'
            element={
              <PermissionWrapper subject='PERM_APPROVE_AGREEMENT'>
                <TradeDataAgreementChapterReviewNewPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/review-agreement/:idAgreement'
            element={
              <PermissionWrapper subject='PERM_APPROVE_AGREEMENT'>
                <TradeDataAgreementReviewPage />
              </PermissionWrapper>
            }
          />
          <Route
            path='new-rta/chapter/:idChapter/edit'
            element={
              <PermissionWrapper subject='MENU.RTA'>
                <TradeDataAgreementChapterNewPage subject='MENU.RTA' />
              </PermissionWrapper>
            }
          />
          {/* Tariff */}
          <Route
            path='tariff/:typeTariff'
            element={
              <PermissionWrapper
                subject={[
                  'MENU.TARIFF',
                  'MENU.PREF_TARIFF',
                  'MENU.BOUND_TARIFF',
                  'MENU.MFN_TARIFF',
                ]}
              >
                <TariffPage subject='MENU.TARIFF' />
              </PermissionWrapper>
            }
          />
          <Route
            path='tariff/:typeTariff/add'
            element={
              <PermissionWrapper
                subject={[
                  'MENU.TARIFF',
                  'MENU.PREF_TARIFF',
                  'MENU.BOUND_TARIFF',
                  'MENU.MFN_TARIFF',
                ]}
              >
                <TariffDetailPage subject='MENU.TARIFF' />
              </PermissionWrapper>
            }
          />
          <Route
            path='tariff/:typeTariff/:idTariff/edit'
            element={
              <PermissionWrapper
                subject={[
                  'MENU.TARIFF',
                  'MENU.PREF_TARIFF',
                  'MENU.BOUND_TARIFF',
                  'MENU.MFN_TARIFF',
                ]}
              >
                <TariffDetailPage subject='MENU.TARIFF' />
              </PermissionWrapper>
            }
          />
          <Route
            path='tariff/:typeTariff/review-tariff'
            element={
              // <PermissionWrapper subject='PERM_APPROVE_TARIFF'>
              <TariffReviewPage />
              // </PermissionWrapper>
            }
          />
          {/* Master Data HS */}
          <Route
            path='master-data-hs-categories/'
            element={
              <PermissionWrapper subject='MENU.MD.HS_CATEGORIES'>
                <MasterDataHSPage subject='MENU.MD.HS_CATEGORIES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='master-data-hs-categories/add'
            element={
              <PermissionWrapper subject='MENU.MD.HS_CATEGORIES'>
                <MasterDataHSDetailPage subject='MENU.MD.HS_CATEGORIES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='master-data-hs-categories/:idHS'
            element={
              <PermissionWrapper subject='MENU.MD.HS_CATEGORIES'>
                <MasterDataHSDetailPage subject='MENU.MD.HS_CATEGORIES' />
              </PermissionWrapper>
            }
          />

          {/* Role Management */}
          <Route
            path='manage-roles'
            element={
              <PermissionWrapper subject='MENU.MANAGE_AVAILABLE_ROLES'>
                <ManageAvailableRolesPage subject='MENU.MANAGE_AVAILABLE_ROLES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='manage-roles/add'
            element={
              <PermissionWrapper subject='MENU.MANAGE_AVAILABLE_ROLES'>
                <ManageAvailableRolesDetailPage subject='MENU.MANAGE_AVAILABLE_ROLES' />
              </PermissionWrapper>
            }
          />
          <Route
            path='manage-roles/:idRole'
            element={
              <PermissionWrapper subject='MENU.MANAGE_AVAILABLE_ROLES'>
                <ManageAvailableRolesDetailPage subject='MENU.MANAGE_AVAILABLE_ROLES' />
              </PermissionWrapper>
            }
          />

          <Route
            path='manage-user-role'
            element={
              <PermissionWrapper subject='MENU.MANAGE_USER_ROLE'>
                <ManageUserRolePage subject='MENU.MANAGE_USER_ROLE' />
              </PermissionWrapper>
            }
          />

          <Route
            path='manage-user-role/add'
            element={
              <PermissionWrapper subject='MENU.MANAGE_USER_ROLE'>
                <ManageUserRoleDetailPage subject='MENU.MANAGE_USER_ROLE' />
              </PermissionWrapper>
            }
          />

          <Route
            path='manage-user-role/:idAdmin'
            element={
              <PermissionWrapper subject='MENU.MANAGE_USER_ROLE'>
                <ManageUserRoleDetailPage subject='MENU.MANAGE_USER_ROLE' />
              </PermissionWrapper>
            }
          />
        </Route>
      </Routes>
    </FTAImpactProvider>
  )
}

// const SuspensedView: FC<WithChildren> = ({children}) => {
//   const baseColor = getCSSVariableValue('--bs-primary')
//   TopBarProgress.config({
//     barColors: {
//       '0': baseColor,
//     },
//     barThickness: 1,
//     shadowBlur: 5,
//   })
//   return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
// }

const PermissionWrapper: React.FC<{subject: string | string[]; children: any}> = ({
  subject,
  children,
}) => {
  const ability = useAbility(AbilityContext)

  const subjects = Array.isArray(subject) ? subject : [subject]
  const canAccess = subjects.some(
    (s) =>
      ability.can('read', s) ||
      ability.can('read', '/' + s) ||
      ability.can('read', s.replace(/^\//, '')) ||
      ability.can('read', s.split('?')[0]) ||
      ability.can('approve', s)
  )
  return canAccess ? children : <NoPermissionCard />
}

export {PrivateRoutes}
